import { SelectItem } from 'primeng/api';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PersonConferenceChangeStatusForm } from 'src/app/models/iconference.interface';
import { GLOBAL_CONVERTERS } from '../../global.converters';

@Component({
  selector: 'app-person-conference-change-bulk-status-dialog',
  templateUrl: './person-conference-change-bulk-status-dialog.component.html',
  styleUrls: ['./person-conference-change-bulk-status-dialog.component.css']
})
export class PersonConferenceChangeBulkStatusDialogComponent implements OnInit {

  form: UntypedFormGroup;

  fields: SelectItem[] = [
    { label: "Онлайн регистрация", value: 'isAutoreg' },
    { label: "Прибыл", value: 'isArrive' },
    { label: "Оплата", value: 'isPayment' },
    { label: "Нужен бейдж", value: 'isNeedBadge' },
    { label: "Бейдж напечатан", value: 'isBadgePrinted' },
    { label: "Выданы материалы", value: 'isMaterials' },
];
stateOptions: SelectItem[] = [
  { label: "Да", value: true },
  { label: "Нет", value: false },
];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      fieldType: new UntypedFormControl('', Validators.required),
      boolValue: new UntypedFormControl(false, Validators.required),
      dateValue: new UntypedFormControl(new Date())
    })
  }


  onCancel() {
    this.ref.close();
  }

  onSubmit() {
    const data = this.form.value as PersonConferenceChangeStatusForm;
    this.ref.close(data);
  }
}
